import { useState, useEffect } from 'react';
import { useAppSelector } from '../../ducks/hooks';
import { TFlags } from './constants-flags';

// Re-Exporting Flag constants since its always going to be used in pair with hook and component
export { Flags } from './constants-flags';
export const useFlagValue = (flag: TFlags): boolean | undefined => {
  const featureFlags = useAppSelector((state) => state.featureFlags);
  const [flagValue, setFlagValue] = useState<boolean | undefined>();

  useEffect(() => {
    if (featureFlags) {
      setFlagValue(featureFlags[flag]);
    }
  }, [featureFlags, flag]);

  return flagValue;
};
